<template>
    <section class="home-sec6">
        <h2 class="home-sec6-title">انواع تبلیغات در آن کلیک</h2>
        <div class="tab-container">
            <div class="tab-headers">
                <button v-for="(tab, index) in tabTitles" :key="index" :class="{ active: activeTab === index }"
                    @click="activeTab = index">
                    {{ tab }}
                </button>
            </div>
            <div class="tab-content">
                <div v-show="activeTab === 0">
                    <div class="home-sec6-img">
                        <img src="../assets/images/video-ad.png" alt="">
                        <div class="count">5,000,000,000+</div>
                    </div>
                    <div class="home-sec6-txt">
                        <p>تبلیغات ویدیویی بهترین روش برای برندسازی شماست، پس داستان برندتان را در بهترین جای ممکن روایت
                            کنید. تبلیغات ویدیویی قبل یا حین ویدیوی اصلی پخش می شود. این نوع از تبلیغات به گفتن روایتی
                            از
                            برند، افزایش فروش و انتقال اطلاعات به طور مختصر و جذاب کمک می کند.
                        </p>
                        <router-link to="/ads/video" class="btn btn--info">اطلاعات بیشتر </router-link>
                    </div>
                </div>
                <div v-show="activeTab === 1">
                    <div class="home-sec6-img">
                        <img src="../assets/images/banner-ad.png" alt="">
                        <div class="count">10,000,000,000+</div>
                    </div>
                    <div class="home-sec6-txt">
                        <p>تبلیغات بنری یکی از روش های پرکاربرد در بازاریابی دیجیتال است که به شما کمک می کند تا به
                            افزایش
                            فروش و برندسازی برسید. با طراحی حرفه ای و جایگاهی مناسب، پیام برندتان را به شیوه ای ماندگار
                            از
                            طریق تبلیغات بنری منتقل کنید.
                        </p>
                        <router-link to="/ads/banner" class="btn btn--info">اطلاعات بیشتر </router-link>
                    </div>
                </div>
                <div v-show="activeTab === 2">
                    <div class="home-sec6-img">
                        <img src="../assets/images/hamsan-ad.png" alt="">
                        <div class="count">20,000,000,000+</div>
                    </div>
                    <div class="home-sec6-txt">
                        <p>هماهنگی تبلیغات همسان با سایر عناصر صفحه به طور طبیعی توجه مخاطب را جلب می کند و به افزایش
                            مشتری
                            شما کمک می کند. پس با استفاده از این روش، می توانید تبلیغات خود را به شکل هدفمند به تعداد
                            زیادی
                            از افرادی که با محتوای سایت درگیر هستند نمایش دهید و تعامل موثرتری ایجاد کنید.
                        </p>
                        <router-link to="/ads/native" class="btn btn--info">اطلاعات بیشتر </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ref, computed, inject } from "vue";
export default {
    name: "HomeSection6",
    setup() {
        const width = inject('viewportWidth');
        const activeTab = ref(0);
        const titles = ['تبلیغات ویدیویی', 'تبلیغات بنری', 'تبلیغات همسان'];
        const tabTitles = computed(() => {
            return width.value < 500
                ? titles.map(title => title.replace('تبلیغات ', ''))
                : titles;
        });

        return {
            activeTab,
            tabTitles,
        };
    }
}
</script>
<style scoped>
@keyframes fadeIn {
    to {
        opacity: 1;
    }
}

.home-sec6 {
    margin-inline: 12.5%;
}

.home-sec6-title {
    width: 50%;
    margin-inline: auto;
    font-size: 28px;
    line-height: 38px;
}

.home-sec6-title,
.count {
    text-align: center;
}


.home-sec6-title,
.count {
    font-family: IRANYekan-Bold;
}

.tab-container {
    margin-top: 3.264%;
}

.tab-headers {
    height: 70px;
}

.tab-headers,
.home-sec6-img,
.home-sec6-txt {
    display: flex;
}

.tab-headers button {
    flex-grow: 1;
    padding: 12px 24px;
    font-size: 24px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(20px);
    border: none;
    border-bottom: 4px solid #D9D9D9;
    color: #000000;
}

.tab-headers button.active {
    border-color: var(--main-pink);
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);
}

.tab-content {
    padding: 32.5px 5.834%;
    box-shadow: 0 0 10px var(--shadow-light);
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
}

.tab-content>div {
    display: grid;
    grid-template-columns: 35% 64.3%;
    gap: 10px;
}

.tab-content>div,
.home-sec6-img {
    align-items: center;
}


.home-sec6-img {
    aspect-ratio: 436 / 385;
    max-height: 385px;
    position: relative;
}

.home-sec6-img img {
    aspect-ratio: 358 / 364;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.count {
    padding: 6px 2%;
    font-size: 30px;
    line-height: 42px;
    border-radius: 20px;
    position: absolute;
    right: 45%;
    top: 0;
    background-color: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(70px);
    box-shadow: 0 0 2px var(--shadow-light);
    border: rgba(255, 171, 184, 0.1);
    opacity: 0;
    animation: fadeIn 2s ease-in forwards;
    color: var(--main-pink);
}

.home-sec6-txt {
    flex-direction: column;
    align-items: start;
    gap: 30px;
}

.home-sec6-txt p {
    line-height: 28px;
    text-align: justify;
}

@media screen and (min-width: 1921px) {
    .home-sec6 {
        width: 1440px;
        margin-inline: auto;
    }
}

@media screen and (max-width: 1440px) {
    .home-sec6 {
        margin-inline: 9.5%;
    }

    .tab-headers button {
        font-size: 20px;
    }

     .count {
        font-size: 24px;
        line-height: 34px;
    }
}

@media screen and (max-width: 1230px) {
    .tab-content>div {
        grid-template-columns: 43% 55.3%;
    }

    .tab-headers button {
        font-size: 18px;
        border-bottom-width: 2px;
    }
}

@media screen and (max-width: 1024px) {
    .home-sec6 {
        margin-inline: 5.556%;
    }

    .home-sec6-title {
        font-size: 24px;
        line-height: 28px;
    }

    .tab-headers button {
        font-size: 16px;
    }

    .tab-headers button,
    .tab-content {
        box-shadow: 0 0 2px var(--shadow-light);
    }

    .count {
        font-size: 20px;
    }

    .home-sec6-txt p {
        line-height: 26px;
    }
}

@media screen and (max-width: 768px) {
    .home-sec6-title {
        width: 98%;
    }

    .tab-container {
        margin-top: 24px;
    }

    .tab-headers {
        background-color: rgba(237, 237, 237, 0.7);
        box-shadow: 0 0 5px var(--shadow-light);
        backdrop-filter: blur(20px);
        height: 44px;
    }

    .tab-headers,
    .tab-headers button {
        border-radius: 10px;
    }

    .tab-headers button {
        border: none;
        font-size: 14px;
        background-color: unset;
    }

    .tab-headers button,
    .tab-content {
        box-shadow: none;
    }

    .tab-headers button.active {
        background-color: #FFFFFF;
        box-shadow: 0 0 5px var(--shadow-light);
    }

    .tab-content {
        padding: 25px 11px 0;
    }

    .tab-content>div {
        grid-template-columns: 100%;
        justify-items: center;
    }

    .home-sec6-img {
        max-height: 180px;
    }

    .home-sec6-txt {
        gap: 12px;
        align-items: center;
    }
}

@media screen and (max-width: 375px) {
    .home-sec6-title {
        font-size: 20px;
    }

    .tab-content {
        padding-inline: 0;
    }


    .home-sec6-txt p {
        font-size: 16px;
    }
}

@media screen and (max-width: 360px) {
    .home-sec6-img {
        max-height: 159px;
    }
}
</style>